import { createElement } from 'react'
import {
    FilterModuleConfig,
    transformToGenericFilterConfig,
} from '@core/modules/filters'
import {
    UnifiedFilterConfig,
    UnifiedFilterModule,
} from '@core/modules/filters/unified-filter.module'
import { SeverityIcon } from '@/ui/components/svg/SeverityIcon'
import { getHighestSeverity } from '@routes/digital-footprint/routes/assets/components/assetsTable/utils'
import { assetsSearchKeys, unifiedAssetsConfig } from './assets.filters'

const config = {
    asset_type: {
        accessor: 'asset_type',
        label: 'Asset type',
        collapsible: true,
        filters: {
            domain: {
                accessor: 'domain',
                label: 'Root Domain',
            },
            subdomain: {
                accessor: 'subdomain',
                label: 'Subdomain',
            },
            email: {
                accessor: 'email',
                label: 'Email Domain',
            },
        },
    },
    severity: {
        accessor: 'severity',
        label: 'Severity',
        collapsible: true,
        filters: {
            critical: {
                accessor: 'critical',
                label: 'Critical',
                icon: createElement(SeverityIcon, { severity: 'critical' }),
            },
            important: {
                accessor: 'important',
                label: 'Important',
                icon: createElement(SeverityIcon, { severity: 'important' }),
            },
            moderate: {
                accessor: 'moderate',
                label: 'Moderate',
                icon: createElement(SeverityIcon, { severity: 'moderate' }),
            },
            clean: {
                accessor: 'clean',
                label: 'Excellent',
                icon: createElement(SeverityIcon, { severity: 'clean' }),
            },
        },
    },
}

const defaultFilters = {
    asset_type: {
        domain: true,
        subdomain: true,
        email: true,
    },
    severity: {
        critical: true,
        important: true,
        moderate: true,
        clean: true,
    },
}

export const domainsFilterConfig: FilterModuleConfig =
    transformToGenericFilterConfig(
        { domains: config },
        { domains: defaultFilters }
    ).domains

export const unifiedDomainsConfig: UnifiedFilterConfig = {
    ...domainsFilterConfig,
    searchKeys: assetsSearchKeys,
    sortStrategy: unifiedAssetsConfig.sortStrategy,
    dataTransformer: (data: TAsset[]) =>
        data.map((asset) => ({
            ...asset,
            severity: getHighestSeverity(asset.issues),
        })),
}

export const unifiedDomainsFilterModule = new UnifiedFilterModule(
    unifiedDomainsConfig,
    'domains.unified.filter'
)
